export default __webpack_public_path__ + "static/media/camLoeppky.dbcf16fc.png";